export { TimepickerConfig } from './timepicker.config';
export { TimepickerComponent } from './timepicker.component';
export { TimepickerModule } from './timepicker.module';



// WEBPACK FOOTER //
// ./src/timepicker/index.ts